import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table, Tag, Tooltip, Typography } from "antd";
import { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import { Consditions, IuserProfile } from "../../datamanagement/models/models-datamanagement";
import dayjs from "dayjs";
import { useId24 } from "../../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../../config/app-config";
import { DatamanagementService } from "../../datamanagement/services/datamanagement-service";
import { useHistory } from "react-router";
import { UserAccess } from "../../../drivers/id24/models/user-access";
import { Role } from "../common";

interface Props {
  tab: { key: string; label: string };
  baseUrl: string;
}
const { Text } = Typography;
export const TableDataManagement: React.FC<Props> = ({ tab, baseUrl }): React.ReactElement => {
  const appConfig = loadAppConfig();
  const { tokenAccess, id24Axios } = useId24();
  const apiBaseUrlCore = id24Axios(appConfig.apiBaseUrl);
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);

  const [loading, setLoading] = useState<boolean>(true);
  const [dataManagement, setDataManagement] = useState<Consditions[]>([]);
  const [AssignUserNew, setAssignUserNew] = useState<string>("");
  const [permissionId24, setPermissionId24] = useState<any>([]);
  const [CleardistNew, setCleardistNew] = useState<string | number>();
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
  });
  const [userProfile, setUserprofile] = useState<IuserProfile>({
    id: 0,
    level: "",
    name: "",
    oaCode: "",
    parentId: "",
    team: "",
    token: "",
    type: "",
    capabilities: {},
  });
  const { push } = useHistory();

  useEffect(() => {
    const loadData = async (tab: string) => {
      mapRoleAccess().then(async (resRoleAccess) => {
        getUserProfile().then(async (resUserProfile) => {
          setUserprofile(resUserProfile);
          setPermissionId24(resRoleAccess);
          const userAssign = () => {
            let AssignUserNew = `User:${resUserProfile.id}:AssignUser`;
            setAssignUserNew(AssignUserNew);
            return AssignUserNew;
          };
          const userCleardist = () => {
            let AssignUserNew = `User:${resUserProfile.id}:AssignUser`;
            setCleardistNew(AssignUserNew);
            return AssignUserNew;
          };
          userCleardist();
          const result = await DatamanagementService(apiBaseUrlCore).getDataManagementRuleBaseByname(userAssign());
          if (result) {
            const resultFilter = await result?.detail?.filter((event: Consditions) => event.status !== "WAITING_APPROVAL");
            const resultDataManagement = resultFilter?.map((item: Consditions, index: number) => {
              return {
                key: index + 1,
                seq: item.seq,
                listname: item.listname,
                days: item.days,
                status: item.status,
                description: item.description,
                createDate: item.createDate,
                updateby: result.name,
                type: item.type,
                fields: item.fields,
                assignType: item.assignType,
                distribution: item.distribution,
                expression: item.expression,
                updateBy: item.updateBy,
                createBy: item.createBy,
                number_dtlLastPay: item.number_dtlLastPay,
              };
            });
            tab === ""
              ? setDataManagement(resultDataManagement)
              : setDataManagement(resultDataManagement.filter((item: Consditions) => item.status === tab));
          }
        });
      });
    };
    loadData(tab.key);
    setLoading(false);
  }, []);

  const mapRoleAccess = () => {
    return new Promise<any>(async (resolve, reject) => {
      const result = tokenAccess?.userAccess.map((group: UserAccess) => group.groupName);
      resolve(result);
    });
  };

  const getUserProfile = async () => {
    return new Promise<IuserProfile>(async (resolve, reject) => {
      const resualProfile = await DatamanagementService(apiBaseUrlDebt).getUserDetail();
      resolve(resualProfile);
    });
  };

  const columns: ColumnsType<Consditions> = [
    {
      title: "No.",
      dataIndex: "key",
      key: "key",
      fixed: "left",
      width: "5%",
      render: (value: string, row: any, index: number) => {
        const current = pagination.current || 1;
        const take = pagination.pageSize || 10;
        const skip = (current - 1) * take;
        return <>{index + 1 + skip}</>;
      },
    },
    {
      title: "List Name",
      dataIndex: "listname",
      key: "listname",
      width: "20%",
      // ellipsis: {
      //   showTitle: false,
      // },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "10%",
      render: (value: any) => {
        let statusText: string = "";
        let color: string = "";
        {
          value === "DRAFT"
            ? ((statusText = "Draft"), (color = "gold"))
            : value === "WAITING_APPROVAL"
            ? ((statusText = "Waiting Approval"), (color = "blue"))
            : value === "APPROVED"
            ? ((statusText = "Approved"), (color = "green"))
            : ((statusText = "Disable"), (color = "red"));
        }

        return <Tag color={color}>{statusText}</Tag>;
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "20%",
      ellipsis: {
        showTitle: false,
      },
      render: (description: string) => (
        <Tooltip placement="topLeft" title={description}>
          {description}
        </Tooltip>
      ),
    },
    {
      title: "Update By",
      dataIndex: "updateBy",
      key: "updateBy",
      filtered: true,
      width: "15%",
    },
    {
      title: "Update Date",
      dataIndex: "createDate",
      key: "createDate",
      width: "16%",

      render: (createDate: number) => {
        return <>{dayjs(createDate).locale("th").add(543, "year").format("DD-MM-YYYY HH:mm")}</>;
      },
    },
    {
      title: "Action",
      dataIndex: "seq",
      width: "10%",
      fixed: "right",
      align: "center",
      render: (index: number, data: any) => {
        return (
          <>
            {data.status === "DRAFT" ? (
              <Button type="link" onClick={() => push(`${baseUrl}/editcondition/draft`, data)}>
                Edit
              </Button>
            ) : data.status === "APPROVED" ? (
              <Button type="link" onClick={() => push(`${baseUrl}/editcondition/showdetail`, data)}>
                View
              </Button>
            ) : (
              <Button type="link" onClick={() => push(`${baseUrl}/editcondition/showdetail`, data)}>
                View
              </Button>
            )}
          </>
        );
      },
    },
  ];
  return (
    dataManagement && (
      <>
        <Row>
          <Text strong>{tab.label}</Text>
        </Row>
        <br></br>
        <Row>
          <Col span={24}>
            <Table
              dataSource={dataManagement}
              columns={columns as any}
              size="small"
              pagination={{ pageSize: 5 }}
              loading={loading}
              style={{ width: "100%" }}
              onChange={(event: TablePaginationConfig) => {
                setPagination({ current: event.current, pageSize: event.pageSize });
              }}
            />
          </Col>
        </Row>
      </>
    )
  );
};
